import styled from "styled-components";



export const TitleComponent = styled.h1`
  color:${props => props.theme.colors.black};
  font-size: 1rem;
  font-weight: 500;  
`